export function languageModelGenerateText() {
  throw new Error('languageModelGenerateText called on the client!');
}
